import React from 'react';
import PropTypes from "prop-types";
import Icon from "../SF/MaterialIcon";
import css from "./Service.scss";

import { getServiceNetworkScheduleUrl, getServiceNetworkUrl } from "utils/successNetworkURL";
import { serviceImageStyle } from "utils/images";
import ServiceWaitingRoom from "./ServiceWaitingRoom";
import ServiceCardFooterOptions from "../serviceCatalog/home/services/ServiceCardFooterOptions";
import commonWidgetCSS from "./CommonWidget.css";
import WaitingRoomLink from 'common/WaitingRoomLink';

const getHoursOfOperations = (hoursOfOperation) => {
  if (!hoursOfOperation) return null;
  return (
    <div className={css.row} data-testid='hoursOfOperation'>
      <Icon aria-hidden="true" icon='schedule'/>
      {hoursOfOperation}
    </div>
  );
}

const getLocation = (location) => {
  if (!location) return null;
  return (
    <div className={css.row} data-testid='location'>
      <Icon aria-hidden="true" icon='place'/>
      <span dangerouslySetInnerHTML={{ __html: location }} />
    </div>
  );
}

const getFooter = (footerProps) => (
  <div className={css.footer}>
    <div>
      {footerProps.onlineSchedulingAvailable &&
      <a href={getServiceNetworkScheduleUrl(footerProps.serviceId)}>SCHEDULE</a>}
      {footerProps.phoneNumber && <a href={`tel:${footerProps.phoneNumber}`}>CALL</a>}
    </div>
    <div>
      <ServiceCardFooterOptions
        serviceId={footerProps.serviceId}
        serviceName={footerProps.serviceName}
        email={footerProps.email}
        url={footerProps.url}
        serviceCalendarEnabled={footerProps.serviceCalendarEnabled}
        isStaff={false}
        isStudent={true}
        upward={footerProps.upwards}
        kioskId={footerProps.kioskId}
        virtualCheckInEnabled={footerProps.virtualCheckInEnabled}
        checkedIntoService={footerProps.checkedIntoService}
        virtualCheckInOpen={footerProps.virtualCheckInOpen}
      />
    </div>
  </div>
);

const Service = (props) => (
  <div className={`${css.contentInner} ${commonWidgetCSS.container}`}  data-role={props.serviceName}>
    <div className={css.contentInnerChild}>
      <div className={css.image} style={serviceImageStyle(props.uuid)}/>
      <div className={css.info}>
        <div className={css.header}>
          <a href={getServiceNetworkUrl(props.serviceId)} className={css.name}>
            {props.serviceName}
          </a>
          <span className={css['large-waiting-room']}>
            <ServiceWaitingRoom
              kioskQueueSize={props.kioskQueueSize}
              kioskMaxWaitTime={props.kioskMaxWaitTime}
              kioskId={props.kioskId}
              kioskType={props.kioskType}
            />
            <WaitingRoomLink checkedIntoService={props.checkedIntoService}
                             isStudent
                             kioskId={props.kioskId}
                             serviceId={props.serviceId}
                             serviceName={props.serviceName}
                             virtualCheckInEnabled={props.virtualCheckInEnabled}
                             virtualCheckInOpen={props.virtualCheckInOpen} />
          </span>
        </div>
        {getHoursOfOperations(props.hoursOfOperation)}
        {getLocation(props.location)}
        <div className={css['small-waiting-room']}>
          <ServiceWaitingRoom
            kioskQueueSize={props.kioskQueueSize}
            kioskMaxWaitTime={props.kioskMaxWaitTime}
            kioskId={props.kioskId}
            kioskType={props.kioskType}
          />
          <WaitingRoomLink checkedIntoService={props.checkedIntoService}
                           isStudent
                           kioskId={props.kioskId}
                           serviceId={props.serviceId}
                           serviceName={props.serviceName}
                           virtualCheckInEnabled={props.virtualCheckInEnabled}
                           virtualCheckInOpen={props.virtualCheckInOpen} />
        </div>
      </div>
    </div>
    {getFooter(props)}
  </div>
);

Service.propTypes = {
  serviceId: PropTypes.number.isRequired,
  uuid: PropTypes.string.isRequired,
  serviceName: PropTypes.string.isRequired,
  location: PropTypes.string,
  kioskMaxWaitTime: PropTypes.number,
  kioskQueueSize: PropTypes.number,
  kioskId: PropTypes.number,
  kioskType: PropTypes.string,
  links: PropTypes.array,
  hoursOfOperation: PropTypes.string,
  phoneNumber: PropTypes.string,
  email: PropTypes.string,
  url: PropTypes.string,
  onlineSchedulingAvailable: PropTypes.bool,
  upwards: PropTypes.bool.isRequired,
  virtualCheckInEnabled: PropTypes.bool,
  checkedIntoService: PropTypes.bool,
  virtualCheckInOpen: PropTypes.bool
};

export default Service;
